export const DEFAULT_DF_APP_ID = 'vt-df-nov14';
export const PROFILE_BUILDER_APP_ID = 'vt-df-profilebuilder';

export const PROFILE_BUILDER_ENABLED = false;
export const PROFILE_BUILDER_FLAG_KEY = 'leadform-split-test-05-2026';
export const PROFILE_BUILDER_VARIANT_COOKIE = 'ld_variant';
export const PROFILE_BUILDER_VISITOR_COOKIE = 'ld_visitor_id';
export const PROFILE_BUILDER_CONVERSION_EVENT = 'DF Lead Submitted';

export type ProfileBuilderVariant = 'A' | 'B';

const PROFILE_BUILDER_ELIGIBLE_SLUGS = new Set(['national-math-tutoring', 'tutoring-national']);

export const isProfileBuilderEligibleSlug = (slugKey: string) => PROFILE_BUILDER_ELIGIBLE_SLUGS.has(slugKey);
